import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import { string, ref } from "yup";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  Tooltip,
  Avatar,
  FormHelperText,
} from "@mui/material";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import { useMutation } from "@apollo/client";
//Icons
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import EmptyImage from "../../Assets/empty-image.png";
import { AuthContext } from "../../Context/AuthContext";
// import { CREATE_USER } from "../../Schema/User"
import CropImageFile from "../CropImage/CropImageFile";
import { UPDATE_SUPPLIER } from "../../Schema/Supplier";
import { SelectUser } from "../Include/DynamicSelect";

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">{`${Math.round(
          props.value
        )}%`}</Typography>
      </Box>
    </Box>
  );
}
LinearProgressWithLabel.propTypes = {
  value: PropTypes.number.isRequired,
};

export default function UpdateSuppiler({
  open,
  handleClose,
  setRefetch,
  editData,
}) {
  // Change Language
  // const { language } = useContext(AuthContext)
  // const { t } = translateLauguage(language)
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  // ========================= upload Image =========================
  const [profileHook, setProfileHook] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [photoURL, setPhotoURL] = useState(null);
  const [openCrop, setOpenCrop] = useState(false);

  const handleUploadImage = (e) => {
    const imageFile = e.target.files[0];
    if (imageFile) {
      setImageFile(imageFile);
      setPhotoURL(URL.createObjectURL(imageFile));
      setOpenCrop(true);
    }
  };

  // ======================= Progress ==============================
  const [statusProgress, setStatusProgress] = useState(false);
  const [progress, setProgress] = useState(10);
  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= 100 ? 100 : prevProgress + 10
      );
    }, 500);
    return () => {
      clearInterval(timer);
    };
  }, []);
  // ===================== End progress =============================

  const [updateSupplier] = useMutation(UPDATE_SUPPLIER, {
    onCompleted: ({ updateSupplier }) => {
      setLoading(false);
      if (updateSupplier?.status) {
        setAlert(true, "success", updateSupplier?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", updateSupplier?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    //     address: Yup.string().required("ទាមទារ!"),
    //     email: Yup.string().required("ទាមទារ!"),
    //     // imageSrc: Yup.string(),
    //     remark: Yup.string(),
    //     name: Yup.string().required("ទាមទារ!"),
    //     tel: Yup.string().required("ទាមទារ!"),
    address: Yup.string(),
    email: Yup.string(),
    // imageSrc: Yup.string(),
    remark: Yup.string(),
    name: Yup.string().required("ទាមទារ!"),
    tel: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      address: "",
      email: "",
      // imageSrc: "",
      remark: "",
      name: "",
      tel: "",
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      //  console.log("values:::", values);
      setLoading(true);
      updateSupplier({
        variables: {
          id: editData?._id,
          input: {
            email: values?.email,
            address: values?.address,
            tel: values?.tel,
            imageSrc: profileHook,
            remark: values?.remark,
            name: values?.name,
          },
        },
      });
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    resetForm,
  } = formik;

  useEffect(() => {
    if (editData) {
      setFieldValue("email", editData?.email);
      setFieldValue("address", editData?.address);
      setFieldValue("tel", editData?.tel);
      setFieldValue("remark", editData?.remark);
      setFieldValue("name", editData?.name);
      setProfileHook(editData?.imageSrc);
    }
  }, [editData, open]);

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              កែប្រែអ្នកប្រើប្រាស់
            </Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12}>
                {!openCrop ? (
                  <Box>
                    <Stack direction="row" justifyContent="center">
                      <Tooltip title="click to upload">
                        <Button component="label" className="btn-upload-user">
                          <TextField
                            type="file"
                            id="image"
                            sx={{ display: "none" }}
                            onChange={handleUploadImage}
                          />
                          <Avatar
                            className="avater-image"
                            src={
                              imageFile
                                ? URL.createObjectURL(imageFile)
                                : editData?.imageSrc
                                ? editData?.imageSrc
                                : EmptyImage
                            }
                          />
                        </Button>
                      </Tooltip>
                    </Stack>
                  </Box>
                ) : (
                  <CropImageFile
                    setProgress={setProgress}
                    setStatusProgress={setStatusProgress}
                    openCrop={openCrop}
                    setOpenCrop={setOpenCrop}
                    photoURL={photoURL}
                    setPhotoURL={setPhotoURL}
                    setImageFile={setImageFile}
                    setProfileHook={setProfileHook}
                  />
                )}

                {statusProgress && progress < 100 ? (
                  <Box sx={{ width: "100%", marginLeft: "20px" }}>
                    <LinearProgressWithLabel value={progress} />
                  </Box>
                ) : (
                  <Typography
                    className="field-title"
                    sx={{ textAlign: "center", marginTop: "10px" }}
                  >
                    រូបភាព
                  </Typography>
                )}
              </Grid>

              <Grid item xs={12}>
                <Typography className="field-title">
                  ឈ្មោះអ្នកផ្គត់ផ្គង់
                </Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  placeholder="ឈ្មោះអ្នកផ្គត់ផ្គង់"
                  {...getFieldProps("name")}
                  error={Boolean(touched.name && errors.name)}
                  helperText={touched.name && errors.name}
                />
              </Grid>
              <Grid item xs={8}>
                <Typography className="field-title">អ៊ីម៉ែល</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  placeholder="email"
                  {...getFieldProps("email")}
                  error={Boolean(touched.email && errors.email)}
                  helperText={touched.email && errors.email}
                />
              </Grid>

              <Grid item xs={4}>
                <Typography className="field-title">លេខទូរស័ព្ទ</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  placeholder="Phone number"
                  {...getFieldProps("tel")}
                  error={Boolean(touched.tel && errors.tel)}
                  helperText={touched.tel && errors.tel}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography className="field-title">អាស័យដ្ឋាន</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  placeholder="អាស័យដ្ឋាន"
                  {...getFieldProps("address")}
                  error={Boolean(touched.address && errors.address)}
                  helperText={touched.address && errors.address}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography className="field-title">Remark</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  multiline
                  rows={2}
                  size="small"
                  placeholder="remark"
                  {...getFieldProps("remark")}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    កំពុងដំណើរការ...
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                    disabled={statusProgress && progress < 100 ? true : false}
                  >
                    កែប្រែ
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
